import {inject, Injectable} from '@angular/core';
import {SyncTable} from '../sync.table';
import {CustomerDocument} from '../../interfaces/customer-documents/customer-document';
import {db} from '../db.service';
import {CustomerDocumentFactory} from '../../factories/customer-documents/customer-document-factory';
import {CustomerDocumentsAdapter} from '../../adapters/customer-documents.adapter';
import {DocumentsService} from '../../services/core/documents.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerDocumentsTable extends SyncTable<CustomerDocument> {

  private readonly _documentsService: DocumentsService;

  constructor() {
    super(db.customerDocuments);
    this._documentsService = inject(DocumentsService);

    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new CustomerDocumentsAdapter<CustomerDocument>({
        api: ['customer-documents'],
        fromObject: CustomerDocumentFactory.fromObject,
        toRemote: CustomerDocumentFactory.toRemote
      })
    };
  }

  /**
   *
   * @param customerId
   */
  public async getByCustomerId(customerId: number): Promise<CustomerDocument[]> {
    return this.table.where('customerId').equals(customerId).toArray();
  }

  /**
   *
   */
  public override async clear(): Promise<void> {
    const customerDocuments = await this.table.toArray();
    for(const customerDocument of customerDocuments) {
      await this._documentsService.deleteDocument(customerDocument.file);
    }
    await super.clear();
  }


}